export function msToTime(ms) {
    // Pad to 2 or 3 digitms, default ims 2
    var pad = (n, z = 2) => ('00' + n).slice(-z);
    return (pad((ms / 3.6e6) | 0) + ':' + pad(((ms % 3.6e6) / 6e4) | 0) + ':' + pad(((ms % 6e4) / 1000) | 0));
}
export function getDateString(date) {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear().toString().slice(-2)}`;
}
